import { ref, watch, onMounted } from "@vue/composition-api";
import { DefaultConfigs } from "../../services/DefaultConfigs";

export default function useDotplotChartDots(dotplotChartDataSetRef, availableWidthRef, availableHeightRef, xRef, yRef, xBandwidthRef) {
  const dots = ref([]);

  const updateDots = () => {
    if (!xRef?.value || !yRef?.value) {
      dots.value = [];
      return;
    }

    const halfXBandwidth = xBandwidthRef.value / 2;
    const newDots = dotplotChartDataSetRef.value.map((d) => ({
      x: xRef.value(d.x) + halfXBandwidth,
      y: yRef.value(d.y),
      color: d.color,
      dotRadius: DefaultConfigs.DotplotChart.dotRadius,
    }));

    dots.value = newDots;
  };

  watch([dotplotChartDataSetRef, availableWidthRef, availableHeightRef, xRef, yRef, xBandwidthRef], updateDots);

  onMounted(updateDots);

  return { dots };
}
